import { MutableRefObject, useEffect, useRef } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
type MaybeRef = MutableRefObject<any> | Function | null;

/**
 * Allows you to point one or more refs at the current value of a single ref.
 * Taken from: https://github.com/tannerlinsley/react-table/discussions/1989
 */
export const useCombinedRefs = (...refs: MaybeRef[]): MutableRefObject<any> => {
    const targetRef = useRef();

    useEffect(() => {
        refs.forEach(ref => {
            if (!ref) return;

            if (typeof ref === 'function') {
                ref(targetRef.current);
            } else {
                // eslint-disable-next-line no-param-reassign
                ref.current = targetRef.current;
            }
        });
    }, [refs]);

    return targetRef;
};
